<template>
	<div id="posterset" v-if="loaded" class="page">
		<div class="poster-box">
			<img class="bg" v-bind:src="poster.image"/>
			<img class="qcode" v-bind:src="qcode"/>
			<input class="name" type="text" v-model="name" placeholder="请输入真实姓名"/>
			<div class="phone">
				教练电话<input class="phone" type="text" v-model="phone" placeholder="请输入手机号码"/>
			</div>
			<div class="school">
				驾校名称<input class="school" type="text" v-model="school" placeholder="请输入驾校名称"/>
			</div>
		</div>
		<div class="btn" v-on:click="event_submit">
			生成海报
		</div>
	</div>
</template>

<script>
import { Toast } from 'we-vue'
export default {
  data () {
    return {
		name:'',
		phone:'',
		school:'',
		loaded:false,
		poster:{},
		qcode:''
	}
  },
  mounted () {
	
  },
  created(){
	this.loaded = true
	this.$app.pr('/api/zposter/set',{
		id:this.$route.query.id
	}).then((res) => {
		this.poster = res.data.zposter
		this.qcode = res.data.qcode
		if(res.data.posterdata){
			this.name = res.data.posterdata.name
			this.phone = res.data.posterdata.phone
			this.school = res.data.posterdata.school
		}
	}).catch((res) => {});
  },
  methods:{
	event_submit(){
		if(!this.name){
			this.$wx.showToast('请填写姓名');
			return false;
		}
		if(!this.phone){
			this.$wx.showToast('请填写手机号码');
			return false;
		}
		if(!this.school){
			this.$wx.showToast('请填写驾校');
			return false;
		}
		this.$wx.showLoading();
		this.$app.pr('/api/zposter/build',{
			id:this.$route.query.id,
			name:this.name,
			phone:this.phone,
			school:this.school
		}).then((res) => {
			this.$wx.hideLoading();
			this.$router.push({path:'/posterdown',query:{
				posterdir:res.data.zposter_image
			}});
		}).catch((res) => {
			this.$wx.showToast('系统错误，请重试')
		});
	}
  },
  filters: {
    pickerValueFilter (val) {
      if (Array.isArray(val)) {
        return val.toString()
      } else {
        return '请选择'
      }
    }
  }
}
</script>

<style scoped>
	#posterset{
		background-color:#FFFFFF;
		min-height:100vh;
	}
	.poster-box{
		padding:3vw;
		position:relative;
	}
	.poster-box .bg{
		width:100%;
	}
	.poster-box .qcode{
		position:absolute;
		width:22vw;
		right:12vw;
		bottom:23vw;
	}
	.poster-box input{
		text-indent:5px;
		height:5vw;
		color:#ffffff;
		height:10vw;
	}
	.poster-box > input{
		position:absolute;
		left:11vw;
		height:10vw;
		border:0px;
		bottom:35vw;
		width:50vw;
		font-size:4vw;
		background-color:rgba(254, 41, 41, 0.57);
	}
	.poster-box .phone{
		width:50vw;
		position:absolute;
		bottom:23vw;
		left:11vw;
		line-height:10vw;
		color:#FFFFFF;
		font-size:4vw;
	}
	.poster-box .phone input{
		width:32vw;
		position:static;
		display:inline-block;
		border:0px;
		float:right;
		background-color:rgba(254, 41, 41, 0.57);
		font-size:4vw;
	}
	.poster-box .school{
		width:50vw;
		position:absolute;
		bottom:35vw;
		font-size:4vw;
	}
	.poster-box .school{
		width:70vw;
		position:absolute;
		bottom:11vw;
		left:11vw;
		line-height:10vw;
		color:#FFFFFF;
		font-size:4vw;
	}
	.poster-box .school input{
		width:52vw;
		position:static;
		display:inline-block;
		border:0px;
		float:right;
		background-color:rgba(254, 41, 41, 0.57);
	}
	.btn{
		height: 12vw;
		display: block;
		margin: 0vw 3vw;
		text-align: center;
		color: #FFFFFF;
		background: -webkit-gradient(linear, left top, right top, from(#fa8d60), to(#e76025));
		background: linear-gradient(to right, #fa8d60, #e76025);
		font-size: 4vw;
		line-height: 12vw;
		border-radius: 10px;
	}
</style>


// WEBPACK FOOTER //
// src/components/Posterset.vue